export default {
  menswear: [
    'ankle',
    'biceps',
    'chest',
    'crossSeam',
    'crossSeamFront',
    'crotchDepth',
    'head',
    'heel',
    'hips',
    'hpsToBust',
    'hpsToWaistBack',
    'inseam',
    'knee',
    'neck',
    'seat',
    'seatBack',
    'shoulderSlope',
    'shoulderToElbow',
    'shoulderToShoulder',
    'shoulderToWrist',
    'upperLeg',
    'waist',
    'waistBack',
    'waistToFloor',
    'waistToHips',
    'waistToKnee',
    'waistToSeat',
    'waistToUpperLeg',
    'wrist',
  ],
  womenswear: [
    'ankle',
    'biceps',
    'bustFront',
    'bustSpan',
    'chest',
    'crossSeam',
    'crossSeamFront',
    'crotchDepth',
    'head',
    'heel',
    'highBust',
    'highBustFront',
    'hips',
    'hpsToBust',
    'hpsToWaistBack',
    'hpsToWaistFront',
    'inseam',
    'knee',
    'neck',
    'seat',
    'seatBack',
    'shoulderSlope',
    'shoulderToElbow',
    'shoulderToShoulder',
    'shoulderToWrist',
    'underbust',
    'upperLeg',
    'waist',
    'waistBack',
    'waistToFloor',
    'waistToHips',
    'waistToKnee',
    'waistToSeat',
    'waistToUnderbust',
    'waistToUpperLeg',
    'wrist',
  ],
}
